import {i18n} from '@/main';
import Vue from 'vue'

let cacheLanguage = "";
let oriCall = "";

class LanguageConfig {
  oriC = undefined;

  /**
   * @param {string} text 提示消息
   * @returns {string}
   */
  convert(text) {
    return i18n.t(text);
  }

  fullTime(str) {
    if (!str) {
      return str;
    }
    str = str.replace('时', this.convert("时"));
    str = str.replace('分', this.convert("分"));
    str = str.replace('秒', this.convert("秒"));
    return str;
  }

  fullGPSSign(str) {
    if (!str) {
      return str;
    }
    str = str.replace('优', this.convert("优"));
    str = str.replace('差', this.convert("差"));
    str = str.replace('良', this.convert("良"));
    return str;
  }

//   convertHook(...args) {
// console.log(args);
//     return oriCall.apply(this, args);
//   }
//
//   constructor() {
//     oriCall = Vue.t;
//     console.log(Vue)
//     Vue.t = this.convertHook;
//     debugger
//
//   }

}

export default new LanguageConfig();



// WEBPACK FOOTER //
// ./src/utils/language.js